import ShortUniqueId from "short-unique-id";
import { v4 as longUid  } from "uuid";
const shortUid = new ShortUniqueId();
export { shortUid, longUid };
